export const getErrorMessage = (error: any, locale: string = "ar") => {
  if (!error) return locale === "ar" ? "حدث خطأ ما" : "Something went wrong";

  // Check if error contains data
  const errorData = error?.data;
  
  if (errorData) {
    // 1. Check for nested validation errors (e.g. Laravel validation errors)
    if (errorData.errors && typeof errorData.errors === "object" && !Array.isArray(errorData.errors)) {
      const firstKey = Object.keys(errorData.errors)[0];
      if (firstKey) {
        const firstError = errorData.errors[firstKey];
        if (Array.isArray(firstError) && firstError.length > 0) {
          return firstError[0];
        } else if (typeof firstError === "string") {
          return firstError;
        }
      }
    }

    // 2. Check if message is an object with locale keys (e.g. { en: "...", ar: "..." })
    if (errorData.message && typeof errorData.message === "object" && !Array.isArray(errorData.message)) {
      if (errorData.message[locale]) {
        return errorData.message[locale];
      }
    }
    
    // 3. Fallback if it's the other locale
    if (errorData.message && typeof errorData.message === "object" && !Array.isArray(errorData.message) && Object.values(errorData.message).length > 0) {
      return Object.values(errorData.message)[0] as string;
    }

    // 4. Check if message is a flat string
    if (typeof errorData.message === "string") {
      return errorData.message;
    }

    // 5. Check if errorData ITSELF is the localized message object (e.g. { en: "...", ar: "..." })
    if (typeof errorData === "object" && !Array.isArray(errorData) && errorData[locale] && typeof errorData[locale] === "string") {
      return errorData[locale];
    }
  }

  // 5. Fallback for RTK Query fetch base query error parsing or regular string errors
  if (typeof error === "string") return error;
  if (error?.message && typeof error.message === "string") return error.message;

  return locale === "ar" ? "حدث خطأ ما" : "Something went wrong";
};
